<template lang="pug">
    div
        span(v-if="copyText") {{copyText}}
        a(
            v-clipboard:copy="text"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
        )  
            | {{$t("global.copyText")}}
</template>
<script>
import Vue from "vue";
import VueClipboard from "vue-clipboard2";

Vue.use(VueClipboard);

export default {
    name: "CopyText",
    props: ["text", "copyText"],
    components: {},
    watch: {},
    created() {},
    data() {
        return {};
    },
    methods: {
        onCopy(e) {
            this.$Message.success("Copy to clipboard!");
        },
        onError(e) {}
    },
    mounted() {},
    computed: {}
};
</script>



// WEBPACK FOOTER //
// src/components/CopyText.vue